import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiClient } from './client';

/* Recruiter profile — Sprint 16a. Resolves the {{recruiter.*}} tokens.
 *  Name + email + role come from the JT JWT and are read-only here; title
 *  and phone are manually editable until JT syncs them. */

export interface Profile {
  id: string;
  jt_user_id: string;
  org_id: string;
  email: string;
  name: string;
  role: string;
  title: string | null;
  phone: string | null;
}

export interface ProfileWritable {
  title?: string | null;
  phone?: string | null;
}

export function useProfile() {
  return useQuery<{ data: Profile }>({
    queryKey: ['profile'],
    queryFn: async () => {
      const { data } = await apiClient.get<{ data: Profile }>('/profile');
      return data;
    },
  });
}

export function useUpdateProfile() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (payload: ProfileWritable) => {
      const { data } = await apiClient.patch<{ data: Profile }>('/profile', payload);
      return data.data;
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ['profile'] }),
  });
}
